<template>
  <div class="performance-by-channel">
    <BubbleChart
      :request-status="requestStatus"
      :title="title"
      :item-id="itemId"
      :series="series"
      :card-options="cardOptions"
      v-bind="$attrs"
      @reload="getData"
    />
    <StLoader
      v-if="requestStatus === 'loading'"
      :loading="true"
    />
  </div>
</template>

<script>
import BubbleChart from '@/components/cards/models/BubbleChart';
import { mapActions } from 'vuex';
import resolversPerformaceByChannel from '@/components/cards/resolvers/resolversPerformanceByChannel';
import StLoader from '@stilingue/st-loader';

export default {
  name: 'PerformanceByChannel',
  components: {
    BubbleChart,
    StLoader,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    type: {
      type: String,
      default: 'performanceByChannel',
    },
  },
  data() {
    const getTooltipHTML = (point) => this.resolver.getTooltipHTML(point);

    return {
      rawSeries: {},
      requestStatus: 'loading',
      cardOptions: {
        tooltip: {
          useHTML: true,
          formatter() {
            return getTooltipHTML(this.point);
          },
          followPointer: false,
          style: {
            pointerEvents: 'auto',
          },
        },
        xAxis: {
          categories: [],
          plotLines: [],
          title: {
            text: this.$t('components.PerformanceByChannel.label.xAxis.title'),
          },
        },
        yAxis: {
          categories: [],
          gridLineWidth: 0,
          tickWidth: 0,
          labels: {
            enabled: false,
          },
          title: {
            text: this.$t('components.PerformanceByChannel.label.yAxis.title'),
          },
        },
      },
    };
  },
  computed: {
    resolver() {
      return resolversPerformaceByChannel[this.type];
    },
    series() {
      return this.resolver.series(this.rawSeries);
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getSacReportsService',
    ]),

    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getSacReportsService({
        itemId: this.itemId,
        servicePath: 'replierByChannel',
        serviceParams: {
          filter: this.filter,
        },
      })
        .then(response => {
          this.requestStatus = 'success';
          this.rawSeries = response;
          if (this.rawSeries.axes) {
            this.cardOptions.xAxis.categories = [...this.rawSeries.axes[0].values, this.$t('components.PerformanceByChannel.label.bubble.total')];
            this.cardOptions.xAxis.plotLines = this.rawSeries.axes[0].values.map((channel, index) => ({
              width: 1,
              value: index + 0.5,
              zIndex: 3,
            }));
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
  },
};
</script>

<style scoped>
.performance-by-channel {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
